// extracted by mini-css-extract-plugin
export default {"icon":"DesktopIcon_icon__CGqfb","iconImage":"DesktopIcon_iconImage__AqhHq","iconTitle":"DesktopIcon_iconTitle__JqmCG"};